export const findBrowserIcon = (browser: string) => {
  const chromeMatch = new RegExp('chrome', 'i')
  const ieMatch = new RegExp('(ie|explorer|edge)', 'i')
  const firefoxMatch = new RegExp('firefox', 'i')
  const safariMatch = new RegExp('safari', 'i')
  const teamsMatch = new RegExp('teams', 'i')

  return chromeMatch.test(browser)
    ? 'chrome'
    : teamsMatch.test(browser)
      ? 'teams'
      : ieMatch.test(browser)
        ? 'ie'
        : firefoxMatch.test(browser)
          ? 'firefox'
          : safariMatch.test(browser)
            ? 'safari'
            : 'browser-unknown'
}

export const findOSIcon = (os: string) => {
  const androidMatch = new RegExp('android', 'i')
  const macMatch = new RegExp('mac', 'i')
  const linuxMatch = new RegExp('linux', 'i')
  const windowsMatch = new RegExp('windows', 'i')
  const iosMatch = new RegExp('ios|iPhone', 'i')

  return windowsMatch.test(os)
    ? 'windows'
    : iosMatch.test(os)
      ? 'ios'
      : macMatch.test(os)
        ? 'mac'
        : androidMatch.test(os)
          ? 'android'
          : linuxMatch.test(os)
            ? 'linux'
            : 'os-unknown'
}
